import { truckImplementsApi } from "./truckImplements.api";

export const { useGetTruckImplementsQuery, useGetTruckImplementQuery, useSaveTruckImplementMutation, useSaveTruckImplementDeleteMutation } = truckImplementsApi;
